import { API_BASE_URL } from '../config';

const baseUrl= API_BASE_URL;

export const getCities = async (lang = "fr") => {
  try {
    const response = await fetch(`${API_BASE_URL}placeCity?lang=${lang==='uk'? 'en': lang}`);
    if (!response.ok) {
      throw new Error("Failed to fetch cities");
    }
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error("Error fetching cities:", error);
    throw error;
  }
};

export const getPlaceStyles = async (lang = "fr") => {
  try {
    const response = await fetch(
      `${API_BASE_URL}placeStyles?lang=${lang==='uk'? 'en': lang}`
    );
    if (!response.ok) {
      throw new Error("Failed to fetch place styles");
    }
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error("Error fetching place styles:", error);
    throw error;
  }
};

export const getPlaceTypes = async (lang = "fr") => {
  try {
    const response = await fetch(
      `${API_BASE_URL}placeTypes?lang=${lang==='uk'? 'en': lang}`
    );
    if (!response.ok) {
      throw new Error("Failed to fetch place types");
    }
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error("Error fetching place types:", error);
    throw error;
  }
};

export const getPlaceUsagesForPresentation = async (lang = "fr") => {
  try {
    const response = await fetch(
      `${API_BASE_URL}static_page_prestations?lang=${lang==='uk'? 'en': lang}`
    );
    if (!response.ok) {
      throw new Error("Failed to fetch place usages");
    }
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error("Error fetching place usages:", error);
    throw error;
  }
};

export const getPlaceOptions = async (lang = "fr") => {
  try {
    const response = await fetch(`${API_BASE_URL}places?order_type=best_note&type=zoom&lang=${lang==='uk'? 'en': lang}`);
    if (!response.ok) {
      throw new Error("Failed to fetch place options");
    }
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error("Error fetching place options:", error);
    throw error;
  }
};

export const getReviews = async (lang = "fr") => {
  try {
    const response = await fetch(
      `${API_BASE_URL}customerReviews?lang=${lang==='uk'? 'en': lang}`
    );
    if (!response.ok) {
      throw new Error("Failed to fetch reviews");
    }
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error("Error fetching reviews:", error);
    throw error;
  }
};

export const getArticles = async (lang = "fr") => {
  try {
    const response = await fetch(
      `https://www.blog.chooseandwork.com/wp-json/wp/v2/posts?_embed&lang=${lang==='uk'? 'en': lang}`
    );
    if (!response.ok) {
      throw new Error("Failed to fetch articles");
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching articles:", error);
    throw error;
  }
};


export const getHomepageLogos = async (lang = "fr") => {
  try {
    const response = await fetch(
      `${API_BASE_URL}seekers/homepage-logos?lang=${lang === 'uk' ? 'en' : lang}`
    );
    if (!response.ok) {
      throw new Error("Failed to fetch homepage logos");
    }
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error("Error fetching homepage logos:", error);
    throw error;
  }
};

export const getPlaceNotesCount = async (lang = "fr") => {
  try {
    const response = await fetch(
      `${API_BASE_URL}pages/place-notes-count?lang=${lang === 'uk' ? 'en' : lang}`
    );
    if (!response.ok) {
      throw new Error("Failed to fetch place notes count");
    }
    const data = await response.json();
    return data.data; // Assuming the API returns {data: count}
  } catch (error) {
    console.error("Error fetching place notes count:", error);
    throw error;
  }
};

export const getTotalSpaces = async (lang = "fr") => {
  try {
    const response = await fetch(
      `${API_BASE_URL}places/total-spaces?lang=${lang === 'uk' ? 'en' : lang}`
    );
    if (!response.ok) {
      throw new Error("Failed to fetch total spaces");
    }
    const data = await response.json();
    return data.data; // Assuming the API returns {data: totalSpaces}
  } catch (error) {
    console.error("Error fetching total spaces:", error);
    throw error;
  }
};